import {useEffect, useCallback, useReducer, useState} from 'react';
import dynamic from 'next/dynamic';

import {useApp} from '@context/AppProvider';
import {useCart} from '@context/CartProvider';
import {api} from '@utils/api';
import {reducer} from '@reducers/product/detail/related.js';
import Loading from '@components/Loading';
import {product} from '@utils/product';
//import styles from '@styles/common/KeepShopping.module.scss';
import Item from '@components/product/list/Item';
import styles from '@styles/related.module.scss';
const ProductDetailModal = dynamic(() => import('@models/ProductDetail.modal'));

const initState = {
	products: [],
	btFee: 0,
	goodCausePer: 0,
	stripeFee: 0,
	loading: true,
};

function RelatedProduct(props) {
	const {productId, query} = props;
	const [state, dispatch] = useReducer(reducer, initState);
	const {
		idb: {user, isoCode, session},
	} = useApp();
	const {fetchWishlistCount} = useCart();
	const [isWishlistRemoved, setisWishlistRemoved] = useState(null);
	const loadData = useCallback(async () => {
		dispatch({
			type: 'SET_DATA',
			data: {
				...initState,
				products: [],
				loading: true,
			},
		});
		if (session) {
			let url = `/product/related/${productId}`;
			if (query.category) {
				url += `?category=${query.category}`;
			}
			const res = await api(
				{
					url,
					method: 'get',
				},
				session,
			);

			dispatch({
				type: 'SET_DATA',
				data: {
					products: res.results,
					btFee: res.default_bt_fee,
					currencyData: res.currencyData,
					goodCausePer: res.good_cause_percentage,
					stripeFee:
						isoCode.toLowerCase() === 'au'
							? res.australia_stripe_fee
							: res.international_stripe_fee,
					loading: false,
				},
			});
		}
	}, [session, productId, query.category, isoCode]);

	useEffect(() => {
		loadData();
	}, [loadData]);

	const callBackMethodModal = async () => {
		if (isWishlistRemoved && isWishlistRemoved?.wishlistData?._id) {
			if (!user) return;
			await addToWishlistOrRemove(isWishlistRemoved);
			setisWishlistRemoved(null);
		}
		dispatch({
			type: 'SET_DATA',
			data: {
				showProductModal: false,
				modalData: {},
			},
		});
	};

	const addToWishlistOrRemove = useCallback(
		async data => {
			try {
				const result = await api(
					{
						url: `/wishlist/upsert`,
						method: 'POST',
						data: {
							// eslint-disable-next-line babel/camelcase
							product_id: data._id,
							// eslint-disable-next-line babel/camelcase
							user_wishlist_id: data.wishlistData ? data.wishlistData._id : '',
						},
					},
					session,
				);
				if (result.status) {
					fetchWishlistCount();
					let products = state.products;
					products[state.products.findIndex(fi => fi._id === data._id)][
						'wishlistData'
					] = result.wishlist._id ? result.wishlist : {};
					dispatch({
						type: 'SET_DATA',
						data: {
							products: products,
						},
					});
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
			}
		},
		[dispatch, state, session, fetchWishlistCount],
	);

	return (
		<>
			<div className={styles.listingPageBlock}>
				<div className='container'>
					<div className='row listing-row'>
						<div className={`col-md-12 ${styles.listingColRight}`}>
							<div className={styles.listingRightBlock}>
								{state.loading ? (
									<Loading.LoaderFour length={4} />
								) : state.products.length ? (
									<>
										<h2 className={styles.relatedHeading}>
											Other items you might like
										</h2>
										<p className='mb-20'>
											Give back to your good cause when you shop via our curated
											marketplace.
										</p>
										<div className='row'>
											{state.products.map((p, key) => {
												const data = product(p, null, {});
												let btFee = state.btFee;
												if (p.retailer.length === 1) {
													const r = p.retailer[0];

													if (r && r.transactionChargePercentage) {
														btFee = +r.transactionChargePercentage;
													}
												}
												return (
													<Item
														data={data}
														key={key}
														addToWishlistOrRemove={addToWishlistOrRemove}
														styles={styles}
														state={state}
														btFee={btFee}
														dispatch={dispatch}
														status={true}
														retailerCount={p.retailer?.length}
													/>
												);
											})}
										</div>
									</>
								) : (
									''
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<>
				{state.showProductModal && (
					<ProductDetailModal
						product={state.modalData.product}
						brand={state.modalData.brand}
						currencyData={state.modalData.currencyData}
						mas={state.modalData.mas}
						promotions={state.modalData.promotions}
						settings={state.modalData.settings}
						queryParams={state.modalData.queryParams}
						isBrand={state.modalData.isBrand}
						removeWishlist={setisWishlistRemoved}
						close={callBackMethodModal}
					/>
				)}
			</>
		</>
	);
}

export default RelatedProduct;
